import React, {SyntheticEvent} from 'react'

import {Icon} from '@vio/atlas/Icon'
import {Text} from '@vio/atlas/Text'
import {FormattedMessageWrapper} from '@vio/core/src/localization/components/FormattedMessage'

import {StyledListItem} from '../commonStyles'

interface Props {
  myBookingsUrl: string
}

export const MyBookingsLink = ({myBookingsUrl}: Props) => {
  const handleMyBookingsClick = (event: SyntheticEvent) => {
    event.preventDefault()

    window.location.href = myBookingsUrl
  }

  return (
    <StyledListItem
      as="button"
      hasDivider
      onClick={handleMyBookingsClick}
      prefix={<Icon name="PersonWithLuggage" />}
      title={
        <Text variant="labelM">
          <FormattedMessageWrapper
            id="myBookings"
            defaultMessage="My bookings"
          />
        </Text>
      }
      suffix={<Icon name="ChevronRight" hasMirror />}
    />
  )
}
